import { Box, Typography } from '@mui/material';
import { ArticleType } from '../hooks/useArticlesQuery';
import { UseArticleReducerActions } from '../hooks/useArticle';
import { UserLink } from './DraftStatusMessage';
import Dot from 'components/common/dot/Dot';
import useCompanyQueryData from 'hooks/useCompanyQueryData';
import { ReactComponent as SMEBadge } from 'assets/icons/sme-badge.svg';

type RenderArticleUserProps = {
  article: ArticleType;
  isPublishedByBuildWiseInsights: boolean;
  dispatch: (value: UseArticleReducerActions) => void;
  source?: string;
  isSME?: boolean;
};

function RenderArticleUser({
  article,
  isPublishedByBuildWiseInsights,
  dispatch,
  source,
  isSME,
}: RenderArticleUserProps) {
  const { shouldDisplayCompanyOnUserCards } = useCompanyQueryData();

  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <UserLink
          disableUserLink={!!source}
          onInsightsUserClick={() =>
            dispatch({ type: 'TOGGLE_INSIGHTS_MODAL', payload: true, key: 'openInsightsModal' })
          }
          mail={article.createdBy}
          name={article.userNameToDisplay}
          sx={{ lineHeight: 1.2, display: 'block', textTransform: 'capitalize' }}
        />
        {isSME && (
          <Box
            sx={(theme) => ({
              color: theme.palette.custom.link,
              backgroundColor: theme.palette.custom.aliceBlue,
              display: 'flex',
              alignItems: 'center',
              borderRadius: '4px',
              padding: '0px 4px',
              marginLeft: 1,
              height: '22px',
            })}
          >
            <SMEBadge style={{ width: 14, height: 14, marginRight: 2 }} />
            <Typography sx={{ fontSize: '12px' }}>SME</Typography>
          </Box>
        )}
      </Box>

      <Box>
        <Typography variant="caption" title="Job Title">
          {isPublishedByBuildWiseInsights ? 'From your data' : article.userNameTitleToDisplay || ''}
        </Typography>
        {shouldDisplayCompanyOnUserCards &&
          (article?.primaryCompanyName || article?.userPrimaryCompanyName) && (
            <>
              <Dot />
              <Typography variant="caption" title="Company">
                {article?.primaryCompanyName || article?.userPrimaryCompanyName}
              </Typography>
            </>
          )}
      </Box>
    </Box>
  );
}

export default RenderArticleUser;
